<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed, ref } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { Tooltip, TooltipContent, TooltipTrigger } from '#ui-kit/ui/tooltip'

const props = defineProps<{
  value: string | number | null | undefined
  placeholder?: string
  truncate?: boolean
  class?: HTMLAttributes['class']
}>()

const isEmpty = computed(() => props.value === null || props.value === undefined)

const text = computed(() => (isEmpty.value ? (props.placeholder ?? 'N/A') : props.value))

const valueClass = computed(() => ({ 'text-disabled/30': isEmpty.value, 'min-w-0 truncate': props.truncate }))

const open = ref(false)
let valueEl: HTMLElement | null = null

function rememberValueEl(event: PointerEvent) {
  valueEl = event.currentTarget instanceof HTMLElement ? event.currentTarget : null
}

// Measured when the tooltip asks to open, so it only opens when the text is actually cut off.
function onOpenChange(value: boolean) {
  open.value = value && !!valueEl && valueEl.scrollWidth > valueEl.clientWidth
}
</script>

<template>
  <div :class="cn('flex items-center px-2 py-1', props.class)">
    <Tooltip v-if="props.truncate && !isEmpty" :open="open" @update:open="onOpenChange">
      <TooltipTrigger as-child>
        <span :class="valueClass" @pointerenter="rememberValueEl">{{ text }}</span>
      </TooltipTrigger>
      <TooltipContent>{{ text }}</TooltipContent>
    </Tooltip>
    <span v-else :class="valueClass">{{ text }}</span>
  </div>
</template>
